import Vue from "vue";
import Vuex from "vuex";
import Map from "./store/Map.js";
import Dossiers from "./store/Dossiers.js";
import Cerfa from "./store/Cerfa.js";
import Document from "./store/Document.js";
import Authentification from "./store/Authentification.js";
import BroadCastMessage from "./store/BroadCastMessage.js";
import Perimeter from "./store/Perimeter.js";
import Log from "./store/Log.js";
import State from "./store/State.js";
import User from "./store/User.js";
import Petitioner from "./store/Petitioner.js";
import StepperDemande from "./store/StepperDemande.js";
import Contact from "./store/Contact.js"
import GED from "./store/GED.js"
import Maintenance from "./store/Maintenance.js"


Vue.use(Vuex);

// ..................................................................................................................................................................................................
// ...............................................................................STORE DE BASE......................................................................................................
// ..................................................................................................................................................................................................

// ..................................................................................NAMESPACE......................................................................................................
export default new Vuex.Store({
  namespaced: true,
  modules: {
    Authentification: Authentification,
    BroadCastMessage: BroadCastMessage,
    Map: Map,
    Dossiers: Dossiers,
    Cerfa: Cerfa,
    User: User,
    StepperDemande: StepperDemande,
    Petitioner: Petitioner,
    Perimeter: Perimeter,
    State: State,
    Document: Document,
    Log: Log,
    Contact: Contact,
    GED: GED,
    Maintenance: Maintenance,
  },
});